/**
 * @file src/pages/ProviderCallback.jsx
 * @description Login provider callback
 */
import React, {Component} from 'react';
import loader from '../styles/images/loader.gif';
import urlHandler from '../utils/urlHandler';
import JWTToken from '../utils/JWTToken';
import { BroadcastChannel } from 'broadcast-channel';

class ProviderCallback extends Component {

    /**
     * @function constructor
     * @param {object} props - Component properties
     */
    constructor(props){
        super(props);
        this.authenticate = this.authenticate.bind(this);
        this.closeAuthWindow = this.closeAuthWindow.bind(this);

        this.state =  {
            code: null,
            state: null,
            error: null,
            message: 'Authenticating ...'
        };

    }

    /**
     * @function componentDidMount
     * @description Called when component is mounted
     */
    componentDidMount() {     

        const protocol = decodeURIComponent(this.props.match.params.protocol) || null;
        const provider = decodeURIComponent(this.props.match.params.provider) || null;
        let params = null;
        if (this.props.location && this.props.location.search) {
            params = new URLSearchParams(this.props.location.search);
        }

        this.setState({
            code: params ? params.get('code') : null,
            state: params ? params.get('state') : null,
            protocol,
            provider
        }, () => {
            this.authenticate();
        })
    }

    componentDidUpdate() {
    }

    /**
     * @function closeAuthWindow
     * @description Close the current provider auth login window/tab
     */
    closeAuthWindow() {
        if (window) {
            window.close();
        }
    }

    /**
     * @function authenticate
     * @description Check provider authentication information and broadcast login information to complete login (back on login page)
     */
    authenticate() {
        if (this.state.protocol && this.state.provider) {
            if (this.state.code && this.state.state) {

                // Call backend to authenticate with provider information
                urlHandler.authenticateCallbackForProvider(this.state.protocol, this.state.provider, this.state.code, this.state.state, (result, status) => {
                    if (status == 200) {
                        try {

                            // Get the user id from the JWT Token returned
                            let jwtToken = new JWTToken(result.token);
                            if (jwtToken) {

                                // Broadcast the provider login
                                var channel = new BroadcastChannel('fft_minisite');
                                channel.postMessage({
                                    type: 'login:provider',
                                    data: {
                                        provider: this.state.provider,
                                        protocol: this.state.protocol,
                                        userId: jwtToken.userId,
                                        token: result.token,
                                        issuedAt: result.issuedAt || null,
                                        expiresAt: result.expiresAt || null
                                    }
                                });
                                channel.close();
    
                                this.closeAuthWindow();
                            }
                        } catch(ex) {
                            this.setState({
                                error: ex.message
                            })  
                        }
                    } else {
                        this.setState({
                            error: result.error_message
                        })   
                    }
                })
            } else {
                this.setState({
                    error: 'Missing auth code and/or state in callback'
                })
            }
        } else {
            this.setState({
                error: 'Unknown protocol and/or provider'
            })
        }
    }

    /**
     * @function render
     * @description Renders the React component
     * @returns React component
     */
    render() {
        return (
            <div className='login-wrapper'>
                <div className="provider-callback">
                    <img src={loader}/>
                    {this.state.error ?
                        <div>
                            <div className="error">{this.state.error}</div>
                            <button type="button" onClick={() => { this.closeAuthWindow() }}>Close</button>
                        </div>
                        :
                        <div>{this.state.message}</div>
                    }
                </div>
            </div>
        );
    }
}

export default ProviderCallback;